export default "__VITE_ASSET__C1GYSng1__"